"use strict";
//-----------------------------------------------------------------------------
// typings
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDispatches = exports.makeCommits = exports.makeGetters = void 0;
function makeGetters(store, module, g) {
    var o = {};
    var _loop_1 = function (p) {
        Object.defineProperty(o, p, { get: function () { return store.getters["".concat(module, "/").concat(p)]; } });
    };
    for (var p in g) {
        _loop_1(p);
    }
    return o;
}
exports.makeGetters = makeGetters;
function makeCommits(store, module, m) {
    var o = {};
    var _loop_2 = function (p) {
        o[p] = function (payload, options) {
            return store.commit("".concat(module, "/").concat(p), payload, options);
        };
    };
    for (var p in m) {
        _loop_2(p);
    }
    return o;
}
exports.makeCommits = makeCommits;
function makeDispatches(store, module, a) {
    var o = {};
    var _loop_3 = function (p) {
        o[p] = function (payload) { return store.dispatch("".concat(module, "/").concat(p), payload); };
    };
    for (var p in a) {
        _loop_3(p);
    }
    return o;
}
exports.makeDispatches = makeDispatches;
//-----------------------------------------------------------------------------
//# sourceMappingURL=nvuex.js.map